module.exports = "<main class=\"content up-menu\">\n    <dashboard-up-menu-comp></dashboard-up-menu-comp>\n    <div class=\"container page-actions\">\n        <iframe id=\"dasboard\" [ngStyle]=\"{height : UpdateHeightIframe()}\">\n        </iframe>\n    </div>\n</main>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/dashboard/html/dashboard.html
// module id = ./src/app/components/dashboard/dashboard/html/dashboard.html
// module chunks = main